/**
 * Stable CSS class names for E2E — Rule template create/edit modal.
 */
export const RTTM = {
    modalRoot: 'rule-template-modal',
    modalPaper: 'rule-template-modal__paper',
    modalTitle: 'rule-template-modal__title',
    modalCloseButton: 'rule-template-modal-input--button-close',
    modalCloseIcon: 'rule-template-modal__close-icon',

    form: 'rule-template-modal__form',
    formGrid: 'rule-template-modal__form-grid',

    fieldName: 'rule-template-modal-input__name',
    fieldTenant: 'rule-template-modal-input__tenant',

    criteriaSection: 'rule-template-modal__criteria-section',
    addCriteriaButtonWrap: 'rule-template-modal__add-criteria-button-wrap',
    addCriteriaButton: 'rule-template-modal-input--button-add-criteria',
    criteriaRows: 'rule-template-modal__criteria-rows',
    criteriaRow: 'rule-template-modal__criteria-row',

    criteriaTypeLabel: 'rule-template-modal-input__criteria-type-label',
    criteriaTypeSelect: 'rule-template-modal-input__criteria-type-select',
    criteriaTypeSelectItem: 'rule-template-modal-input__criteria-type-select-item',

    operatorLabel: 'rule-template-modal-input__operator-label',
    operatorSelect: 'rule-template-modal-input__operator-select',
    operatorSelectItem: 'rule-template-modal-input__operator-select-item',

    removeCriteriaButton: 'rule-template-modal-input--button-remove-criteria',
    removeCriteriaIcon: 'rule-template-modal__remove-criteria-icon',

    operatorsTooltip: 'rule-template-modal__operators-tooltip',
    operatorsHelpButton: 'rule-template-modal-input--button-operators-help',
    operatorsHelpIcon: 'rule-template-modal__operators-help-icon',
} as const;

export const rttmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

